/* eslint-disable prettier/prettier */
import React, { Fragment } from 'react';

import moment from 'moment';

import FilterTag from 'components/Filters/components/FilterTag';
import { SearchParams } from 'components/TripSearch/models';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { statusTranslation } from 'utils/statusTag';

import { Container } from './styles';

interface Props {
  params: SearchParams;
  onChange: (params: SearchParams) => void;
  defaultInitDate?: string;
  defaultEndDate?: string;
}
const FilterTags = ({ params, onChange, defaultInitDate, defaultEndDate }: Props) => {
  const { t } = useStoreTranslation();
  const DateTag = () => (
    <Fragment>
      {params.initDate &&
        params.endDate &&
        params.initDate !== defaultInitDate &&
        params.endDate !== defaultEndDate && (
          <FilterTag
            onDelete={() => {
              const newParams: SearchParams = {
                ...params,
                initDate: defaultInitDate ?? undefined,
                endDate: defaultEndDate ?? undefined,
              };
              delete newParams.initDate;
              delete newParams.endDate;
              onChange(newParams);
            }}
          >
            {moment(params.initDate).format('ddd DD, MMM')} - {moment(params.endDate).format('ddd DD, MMM')}
          </FilterTag>
        )}
    </Fragment>
  );

  const DestinationTag = () => (
    <Fragment>
      {params.destination && (
        <FilterTag
          onDelete={() => {
            const newParams: SearchParams = {
              ...params,
              destination: undefined,
            };
            delete newParams.destination;
            onChange(newParams);
          }}
        >
          {params.destination.related_city ?? params.destination.code}
        </FilterTag>
      )}
    </Fragment>
  );

  const TripTypeTag = () => (
    <Fragment>
      {params.tripType && (
        <FilterTag
          onDelete={() => {
            const newParams: SearchParams = {
              ...params,
              tripType: undefined,
            };
            delete newParams.tripType;
            onChange(newParams);
          }}
        >
          {t(`myTrips.search.product.options.${params.tripType.toLowerCase()}`)}
        </FilterTag>
      )}
    </Fragment>
  );

  const DistanceRestrictionTag = () => (
    <Fragment>
      {params.distanceRestriction && (
        <FilterTag
          onDelete={() => {
            const newParams: SearchParams = {
              ...params,
              distanceRestriction: undefined,
            };
            delete newParams.distanceRestriction;
            onChange(newParams);
          }}
        >
          {t(`myTrips.search.distanceRestriction.options.${params.distanceRestriction}`)}
        </FilterTag>
      )}
    </Fragment>
  );

  const TravelStatusTag = () => (
    <Fragment>
      {params.travelStatus && (
        <FilterTag
          onDelete={() => {
            const newParams: SearchParams = {
              ...params,
              travelStatus: undefined,
            };
            delete newParams.travelStatus;
            onChange(newParams);
          }}
        >
          {t('myTrips.search.travelStatus.label')}: {statusTranslation(params.travelStatus, t)}
        </FilterTag>
      )}
    </Fragment>
  );

  const TravelItineraryIdTag = () => (
    <Fragment>
      {params.travelItineraryId && (
        <FilterTag
          onDelete={() => {
            const newParams: SearchParams = {
              ...params,
              travelItineraryId: undefined,
            };
            delete newParams.travelItineraryId;
            onChange(newParams);
          }}
        >
          {t('myTrips.search.travelItineraryId.label')}: {params.travelItineraryId}
        </FilterTag>
      )}
    </Fragment>
  );

  return (
    <Container>
      <DateTag />
      <DestinationTag />
      <TripTypeTag />
      <DistanceRestrictionTag />
      <TravelStatusTag />
      <TravelItineraryIdTag />
    </Container>
  );
};
export default FilterTags;
